/**
 * <pre>
 * User utility functions.
 *
 * Summary of responsibilities:
 *
 *  - provides commonly used functionality that can be called from anywhere.
 * </pre>
 *
 * @author Various
 * @namespace Common.Utils.User
 */

/**
 * Creates a random unique UID
 *
 * @memberOf Common.Utils.User
 *
 * @param {boolean} rndCase (include upper and lower case?)
 * @returns {string}
 */
function createUUID(rndCase){

	var uv = '89ab';
	var rndS = '', i, c;

	for (i = 0; i < 32; i++){
		c = (Math.random() * 16 | 0).toString(16);
		if (rndCase && (rndCase == true) && (Math.round(Math.random()) == 1)){
			c = c.toUpperCase();
		}
		rndS += c;
	}

	return [rndS.substr(0,8),
		rndS.substr(8,4),
		"4" + rndS.substr(12,3),
		uv.charAt(Math.random() * 4 | 0) + rndS.substr(16,3),
		rndS.substr(20,12)
	].join("-");
}
export { createUUID }